import { proposalsService } from '@/services/proposals';
import type { GetProposalsParams } from '@/services/proposals/types';
import { useQuery } from '@tanstack/react-query';

interface UseProposalsOptions extends GetProposalsParams {
  enabled?: boolean;
}

export function useProposals(options: UseProposalsOptions = {}) {
  const { enabled = true, ...params } = options;

  return useQuery({
    queryKey: ['proposals', params],
    queryFn: async () => {
      const response = await proposalsService.getProposals(params);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar propostas');
      }

      return response.data;
    },
    staleTime: 0, // Sempre busca na base ao acessar a lista de propostas
    enabled,
  });
}
